<template>
  <div>
    <VDatePicker
      v-model="data.startDate"
      class="d-flex"
      :value="data.startDate"
      :label="$t('billing.filter.from')"
      @input="updateData"
    />
    <v-checkbox
      v-model="data.copyPreviousPrice"
      :label="$t('aquassistBilling.pricingManagement.labels.copyPreviousPrice')"
      color="primary"
      @change="updateData"
    />
  </div>
</template>

<script>
import VDatePicker from '@/components/shared/widgets/forms/VuetifyInputs/VDatePicker.vue';

export default {
    name: 'PricingPeriodForm',
    components: {
        VDatePicker,
    },

    data: () => ({
        data: {
            startDate: null,
            copyPreviousPrice: false,
        },
    }),
    methods: {
        pricingPeriodValidation() {
            return !!this.data.startDate;
        },
        emitChange() {
            this.$emit('inputChange', this.pricingPeriodValidation);
        },
        updateData() {
            this.emitChange();
            this.$emit('sendData', this.data);
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .v-input--selection-controls{
    margin: 0;
    padding: 0;
}
</style>
